import { Injectable } from "@angular/core";
import { FileOpener } from "@awesome-cordova-plugins/file-opener/ngx";
import { File } from "@awesome-cordova-plugins/file/ngx";
import { DeviceHelper, PlatformName } from "../../gyzmo-commons/helpers/device.helper";
import { LoadingHelper } from "../../gyzmo-commons/helpers/loading.helper";
import { LoggerService } from "../../gyzmo-commons/services/logs/logger.service";

declare var cordova: any;
declare var window;

@Injectable({
    providedIn: "root",
})
export class FileService {
    private _fs: string = "";

    constructor(private logger: LoggerService,
                private file: File,
                private fileOpener: FileOpener,
                private loadingHelper: LoadingHelper,
                private deviceHelper: DeviceHelper) {
    }

    public initialiseFileSystem() {
        this.logger.info(this.constructor.name, "initialiseFileSystem");

        switch (this.deviceHelper.getPlatform()) {
            case PlatformName.IOS:
                this._fs = (cordova.file) ? cordova.file.documentsDirectory : "";
                break;
            case PlatformName.ANDROID:
                this._fs = (cordova.file) ? cordova.file.externalDataDirectory : "";
                break;
        }
    }

    public async saveAndOpenPdf(pdf: string, filename: string) {
        if (this.deviceHelper.isRunningOnDevice()) {
            await this.loadingHelper.showLoading();
            await this.file.writeFile(this._fs, filename, this.convertBase64ToBlob(pdf, "data:application/pdf;base64"), { replace: true })
                .catch((reason) => {
                    this.logger.error(this.constructor.name, "Error writing pdf file (" + reason + ")");
                });
            await this.fileOpener.open(this._fs + filename, "application/pdf")
                .catch((reason) => {
                    this.logger.error(this.constructor.name, "Error opening pdf file (" + reason + ")");
                });
            await this.loadingHelper.hideAll();
        } else {
            let newWindow = window.open("");
            newWindow.document.write("<body style='margin:0;overflow:hidden'><iframe width='100%' height='100%' src='" + pdf + "'></iframe></body>");
            newWindow.document.close();
        }
    }

    private convertBase64ToBlob(b64Data, contentType): Blob {
        contentType = contentType || "";
        const sliceSize = 512;
        b64Data = b64Data.replace(/^[^,]+,/, "");
        b64Data = b64Data.replace(/\s/g, "");
        const byteCharacters = window.atob(b64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }
}
